import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { fetchOrganizationInfo } from "~/thunks/organizationThunks";
import { getUniqueByField } from "~/utils/utils";
import { fetchSurvey } from "~/thunks/surveyThunks";
import type { RootState } from "~/store";
import type { User } from "~/types/userManagement";
import type { Message, MessageChat } from "~/types/chat";
import { genericDeleteThunk } from "~/thunks/deleteThunks";
import { fetchAsset } from "~/thunks/assetsThunks";


interface ChatState {
    messages: MessageChat[];
    users: User[]; // Adjust type as needed
    open: boolean;
};

const initialState: ChatState = {
    messages: [],
    users: [],
    open: false,
};

const chatSlice = createSlice({
    name: "chat",
    initialState,
    reducers: {
        addMessage: (state, action: PayloadAction<MessageChat>) => {
            state.messages.push(action.payload);
        },
        setUsers: (state, action: PayloadAction<User[]>) => {
            state.users = action.payload;
        },
        setChatOpen: (state, action: PayloadAction<boolean>) => {
            state.open = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOrganizationInfo.fulfilled, (state, action: PayloadAction<any>) => {
                console.log("fetchOrganizationInfo fulfilled", action.payload);
                let users = action.payload.orgUsers ? action.payload.orgUsers : action.payload.provUsers;
                users = getUniqueByField("user_id", users);
                state.users = users || [];

            })
            .addCase(fetchAsset.pending, (state, action: PayloadAction<any>) => {
                console.log("fetchAsset pending", action.payload);
                Object.assign(state, initialState); // Reset state to initial state
            })
            .addCase(fetchSurvey.fulfilled, (state, action: PayloadAction<any>) => {
                console.log("fetchSurvey fulfilled", action.payload);
                state.messages = action.payload.messages;
            })
            .addCase(genericDeleteThunk.fulfilled, (state, action: PayloadAction<any>) => {
                const operations = action.payload
                operations.forEach((operation: any) => {

                    if (operation.table === "tbl_messages") {
                        console.log("genericDeleteThunk fulfilled", action.payload);

                        state.messages = state.messages.filter(msg => !operation.ids.includes(msg.id));
                        console.log("Updated messages after deletion", state.messages.length);
                    }
                })
                // state.messages = action.payload.messages;
            })
            // .addCase(createThunk.fulfilled, (state, action: PayloadAction<{ dataType: string; data: Message }>) => {
            //     console.log("createThunk fulfilled", action.payload);
            //     if (action.payload.dataType === "messages"){
            //         // console.log(state.messages)
            //         // state.messages.push(action.payload.message);
            //         state.messages = [...state.messages, action.payload.data];
            //     }
            // })
    },
});

export const { addMessage, setChatOpen } = chatSlice.actions;
export const selectChat = (state: RootState) => state.chat;
export const selectMessages = (state: RootState) => state.chat.messages;
export const selectUsers = (state: RootState) => state.chat.users;
export const selectChatOpen = (state: RootState) => state.chat.open;

export default chatSlice.reducer;